<mat-dialog-content>
    <mat-card appearance="outlined" class="mat-mdc-elevation-specific mat-elevation-z8">
        <mat-card-header>
            <mat-card-title>{{data.tableName}}</mat-card-title>
            <mat-card-subtitle>{{data.tableDescription}}</mat-card-subtitle>
        </mat-card-header>
        <div class="form-container">
            <form  #dataForm="ngForm">
                <mat-form-field *ngFor="let col of data.cols" style="width: 400px;">
                    <mat-label>{{col.name}}</mat-label>
                    <input matInput name="{{col.name}}" [(ngModel)]="data.record[col.name]">
                </mat-form-field>
            </form>
        </div>
    </mat-card>

    <div class="button-container">
        <button mat-raised-button color="accent" (click)="save()" [disabled]="documentIsEmpty() || !this.data.canEdit">Save</button>
        <button mat-raised-button color="warn" style="margin-left: 10px;" (click)="cancel()">Cancel</button>

        <div style="float: right;">
            <button mat-raised-button color="warn" style="margin-left: 10px;" (click)="delete()" [disabled]="data.new || !this.data.canEdit">Delete Row</button>
        </div>
    </div>
</mat-dialog-content>